const BIAS_BADGE_STRATEGIES = new Set(['SHORT_STRANGLE', 'SHORT_STRADDLE', 'CALL_SPREAD', 'PUT_SPREAD']);

export const getOperationBiasBadgeMeta = (operation, t) => {
  if (!operation || !BIAS_BADGE_STRATEGIES.has(operation.strategy_label)) return null;

  if (operation.directional_bias === 'NEUTRAL') {
    return {
      label: t('positions.balanced'),
      className: 'border-white/10 bg-white/[0.05] text-white/80',
    };
  }

  if (operation.directional_bias === 'BULLISH') {
    return {
      label: t('positions.bullishBias'),
      className: 'border-[#22C55E]/20 bg-[#22C55E]/10 text-[#BDFACD]',
    };
  }

  if (operation.directional_bias === 'BEARISH') {
    return {
      label: t('positions.bearishBias'),
      className: 'border-[#EF4444]/20 bg-[#EF4444]/10 text-[#FFC5C5]',
    };
  }

  return null;
};

export const formatOperationDirectionalBiasLabel = (operation, t) => {
  if (!operation) return '—';
  if (operation.strategy_label === 'SHORT_STRANGLE' || operation.strategy_label === 'SHORT_STRADDLE') {
    if (operation.directional_bias === 'NEUTRAL') return t('positions.balanced');
    if (operation.directional_bias === 'BULLISH') return t('positions.bullishBias');
    if (operation.directional_bias === 'BEARISH') return t('positions.bearishBias');
  }

  if (operation.directional_bias === 'BULLISH') return t('positions.bullish');
  if (operation.directional_bias === 'BEARISH') return t('positions.bearish');
  if (operation.directional_bias === 'NEUTRAL') return t('positions.balanced');
  return operation.directional_bias || '—';
};

export default getOperationBiasBadgeMeta;